// src/api/admin/admin.js
import { API_BASE } from '../../utils/api';

function authHeaders() {
  const t = localStorage.getItem('adm_t');
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function listAdminBookings(params = {}) {
  const qs = new URLSearchParams(params);
  const res = await fetch(`${API_BASE}/api/admin/bookings?${qs}`, {
    headers: { ...authHeaders() }
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || 'Failed to load bookings');
  // Ensure shape for older servers (defensive)
  if (Array.isArray(data)) return { rows: data, count: data.length };
  return { rows: data.rows || [], count: Number(data.count || 0) };
}